/*
 * 1-Minute Maths
 * Copyright © 2021 - 2024 White Rose Maths
 * VerticalTenFrame.tsx - Vertical Ten Frame layout.
*/

import { StyleSheet, View } from 'react-native';
import { calculateVerticalTenFrameSize } from './TenFrameSizes';
import TenFrameElement from './TenFrameElement';

import type { JSX } from 'react';

interface VerticalTenFrameProps {
  numFrames: number;
  numCounters: number;
  color: 'red' | 'yellow' | 'none';
  usableWidth: number,
  usableHeight: number
}

const VerticalTenFrame = ({ numFrames, numCounters, color: color, usableWidth, usableHeight }: VerticalTenFrameProps): JSX.Element => {

  const { usableElementSize, elementMargin } = calculateVerticalTenFrameSize(numFrames, usableWidth, usableHeight);

  const topCols: JSX.Element[] = [];
  const bottomCols: JSX.Element[] = [];

  for (let i = 0; i < 10; i++) {
    if (i % 2 === 0 && numCounters > 0) {
      topCols.push(
        <TenFrameElement color={color} isFilled width={usableElementSize} height={usableElementSize} margin={elementMargin} key={`topred${i}`} />
      );
      numCounters -= 1;
    }
    else if (i % 2 !== 0 && numCounters > 0) {
      bottomCols.push(<TenFrameElement color={color} isFilled width={usableElementSize} height={usableElementSize} margin={elementMargin} key={`bottomRed${i}`} />);
      numCounters -= 1;
    }

    else if (i % 2 === 0 && numCounters <= 0) {
      topCols.push(
        <TenFrameElement color='none' isFilled={false} width={usableElementSize} height={usableElementSize} margin={elementMargin} key={`topempty${i}`} />
      );
    }
    else {
      bottomCols.push(<TenFrameElement color='none' isFilled={false} width={usableElementSize} height={usableElementSize} margin={elementMargin} key={`bottomempty${i}`} />);
    }
  }

  return (

    <View style={styles.frameWrapper} key='frameWrapper'>
      <View style={styles.tenFrame} key='tenFrame'>
        <View style={styles.row}>
          {topCols}
        </View>
        <View style={styles.row}>
          {bottomCols}
        </View>
      </View>
    </View>
  );
};

export default VerticalTenFrame;

const styles = StyleSheet.create({

  frameWrapper: {
    marginVertical: '2%'
  },

  tenFrame: {
    alignItems: 'center',
    borderWidth: 2,
    borderColor: '#20232a',
    borderStyle: 'solid',
    backgroundColor: 'grey',
    flexDirection: 'column',
    justifyContent: 'center',
    alignContent: 'center',
    display: 'flex',
  },

  row: {
    flexDirection: 'row'
  }

});
